import CssBaseline from '@mui/material/CssBaseline';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/router';
import { FeedbackProvider } from '@/state/feedback';
import AppTheme from '@/theme/AppTheme';
import { ApiQueryProvider } from '@/api/ApiQueryProvider';

function StatefulApp() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <RouterProvider router={router} />
    </>
  );
}

/** Same provider order as bodyprint-web, without workspace, PWA, walkthrough and CSAT. */
function App() {
  return (
    <AppTheme>
      <FeedbackProvider>
        <ApiQueryProvider>
          <StatefulApp />
        </ApiQueryProvider>
      </FeedbackProvider>
    </AppTheme>
  );
}

export default App;
